export var S3PartitionLayout;
(function (S3PartitionLayout) {
    S3PartitionLayout["S3_PARTITION_LAYOUT_HIVE"] = "hive";
    S3PartitionLayout["S3_PARTITION_LAYOUT_DIRECTORY"] = "directory";
    S3PartitionLayout["S3_PARTITION_LAYOUT_FLAT"] = "flat";
})(S3PartitionLayout || (S3PartitionLayout = {}));
